import * as MutationsType from "./mutationsType";
import { ordersStatesCollection } from "@/config/firebase";
import requestAxios from "@/helpers/request_axios";

export default {
  async getTicketStateById({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ticket-states/${id}`,
        method: "GET",
      });

      const state = response.data.data;
      commit(MutationsType.SET_TICKET_STATE, state);
    } catch (error) {
      console.error("getTicketStateById: ", error.response.data);
      throw error.response.data;
    }
  },
  async getAllTicketStates({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ticket-states",
        method: "GET",
      });

      const states = response.data.data;
      commit(MutationsType.SET_TICKET_STATES, states);

      let statesMap = {};
      states.forEach((state) => {
        statesMap[state.id] = state;
      });
      commit(MutationsType.SET_TICKET_STATES_MAP, statesMap);
      return response.data;
    } catch (error) {
      console.error("getAllTicketStates: ", error.response.data);
      throw error.response.data;
    }
  },
  async createTicketState({ commit }, { state }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ticket-states",
        method: "POST",
        data: state,
      });
      commit(MutationsType.ADD_TICKET_STATE, response.data.data);
      return response.data;
    } catch (error) {
      console.error("createTicketState: ", error.response.data);
      throw error.response.data;
    }
  },
  async updateTicketState({ commit }, { state }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ticket-states/${state.id}`,
        method: "PATCH",
        data: state,
      });
      commit(MutationsType.UPDATE_TICKET_STATE, response.data.data);
      return response.data;
    } catch (error) {
      console.error("updateTicketState: ", error.response.data);
      throw error.response.data;
    }
  },
  async removeTicketState({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ticket-states/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.REMOVE_TICKET_STATE, { id });
      return response.data;
    } catch (error) {
      console.error("removeTicketState: ", error.response.data);
      throw error.response.data;
    }
  },
  async getAllOrderStates({ commit }) {
    const snap = await ordersStatesCollection.orderBy("created_at").get();
    let states = [];
    let statesMap = {};
    let data;

    if (!snap.empty) {
      snap.forEach((state) => {
        data = { id: state.id, ...state.data() };
        states.push(data);
        statesMap[state.id] = data;
      });
    }

    commit(MutationsType.SET_ORDER_STATES, states);
    commit(MutationsType.SET_ORDER_STATES_MAP, statesMap);
  },
  resetModuleState({ commit }) {
    commit(MutationsType.SET_TICKET_STATE, null);
    commit(MutationsType.SET_TICKET_STATES, null);
    commit(MutationsType.SET_TICKET_STATES_MAP, {});
    commit(MutationsType.SET_ORDER_STATES, null);
    commit(MutationsType.SET_ORDER_STATES_MAP, {});
  },
};
